
import React from 'react';
import { Box, CheckBox } from 'grommet';

import OdrudyTratYear from './OdrudyTratYear';

function getYears(content) {
    let odrudaTratIds = [];
    let years = [];
    content.forEach(item => {
        if (odrudaTratIds.indexOf(item.odruda_trat_id) === -1) {
            years.push({
                odrudaTratId: item.odruda_trat_id,
                title: `Období: ${item.rok_od} až ${item.rok_do}`
            });
            odrudaTratIds.push(item.odruda_trat_id);
        }
    });
    return years;
}

class OdrudyTratTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showAll: false
        };
    }

    handleShowAll = (event) => {
        this.setState({
            showAll: event.target.checked
        });
    }

    render() {
        let years = getYears(this.props.tratContent);

        return (
            <Box>
                <Box pad={{left: '12px'}}>
                    <CheckBox
                        checked={this.state.showAll}
                        label="Zobrazit všechny odrůdy na trati v jednotlivých obdobích"
                        onChange={this.handleShowAll}
                    />
                </Box>
                <Box direction="row" justify="center" wrap={true}>
                    {years.map(item => {
                        return (
                            <OdrudyTratYear
                                key={item.odrudaTratId}
                                odrudaTrat={item}
                                tratContent={this.props.tratContent}
                                showAll={this.state.showAll}
                            />
                        );
                    })}
                </Box>
            </Box>
        );
    }
};

export default OdrudyTratTable;
